const initialState = {};

export default (state = initialState, action) => {
	switch (action.type) {
		case "PROFILE_STATUSES_IS_LOADING":
			return {
				...state,
				isLoading: 1
			};
		case "PROFILE_STATUSES_HAS_ERROR":
			return {
				...state,
				isLoading: 0,
				error: action.error
			};
		case "PROFILE_STATUSES_SUCCESS":
			return {
				...state,
				statuses: action.data.statuses,
				isLoading: 0
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/profileStatuses.js